import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../components/TableContent';

import { CancelButton } from './components/CancelButton';
import { StatusIcon } from './components/StatusIcon';
import { WithdrawalItemTypes } from './types';

export const WithdrawalItemTablet: React.FC<WithdrawalItemTypes.Props> = ({ item, onCancel }) => {
  // const handleDownloadReceipt = () => {
  //   onDownloadReceipt(item.transactionIdNormalized, item.accountId);
  // };

  const handleCancel = () => {
    onCancel(item.transactionIdNormalized, item.accountId);
  };

  return (
    <TableContent
      direction="row"
      space={Spacing['stack.xxxs']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <VStack space={Spacing['stack.quarck']} flex={2}>
        <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
          Data de Solicitação
        </Text>
        <Text>{item.transactionDateNormalized}</Text>
      </VStack>
      <VStack space={Spacing['stack.quarck']} flex={2}>
        <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
          Data para saque
        </Text>
        <Text>{item.scheduledDateNormalized}</Text>
      </VStack>
      <VStack space={Spacing['stack.quarck']} flex={1}>
        <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
          Valor (R$)
        </Text>
        <Text>{item.amountNormalized}</Text>
      </VStack>
      <VStack space={Spacing['stack.quarck']} flex={2}>
        <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
          Status
        </Text>
        <StatusIcon item={item} />
      </VStack>
      <VStack space={Spacing['stack.quarck']} flex={1} justifyContent="center">
        <CancelButton onPress={handleCancel} isDisabled={!item.canCancel} />
      </VStack>
    </TableContent>
  );
};
